/** @flow */

export const GetEventsCount = "GET_EVENTS_COUNT";
export const GetEventsCountSuccess = "GET_EVENTS_COUNT_SUCCESS";
export const GetEventsCountError = "GET_EVENTS_COUNT_ERROR";

export const GetClassificationsCount = "GET_CLASSIFICATIONS_COUNT";
export const GetClassificationsCountSuccess = "GET_CLASSIFICATIONS_COUNT_SUCCESS";
export const GetClassificationsCountError = "GET_CLASSIFICATIONS_COUNT_ERROR";

export const GetPromptsCount = "GET_PROMPTS_COUNT";
export const GetPromptsCountSuccess = "GET_PROMPTS_COUNT_SUCCESS";
export const GetPromptsCountError = "GET_PROMPTS_COUNT_ERROR";

// Service Settings

export const GetServiceSettings = "GET_SERVICE_SETTINGS";
export const GetServiceSettingsSuccess = "GET_SERVICE_SETTINGS_SUCCESS";
export const GetServiceSettingsError = "GET_SERVICE_SETTINGS_ERROR";
export const UpdateServiceSettings = "UPDATE_SERVICE_SETTINGS";
export const UpdateServiceSettingsSuccess = "UPDATE_SERVICE_SETTINGS_SUCCESS";
export const UpdateServiceSettingsError = "UPDATE_SERVICE_SETTINGS_ERROR";

export const GetServiceSettingsSchema = "GET_SERVICE_SETTINGS_SCHEMA";
export const GetServiceSettingsSchemaSuccess = "GET_SERVICE_SETTINGS_SCHEMA_SUCCESS";
export const GetServiceSettingsSchemaError = "GET_SERVICE_SETTINGS_SCHEMA_ERROR";

export const SetEditedServiceSettings = "SET_EDITED_SERVICE_SETTINGS";
export const ClearEditedServiceSettings = "CLEAR_EDITED_SERVICE_SETTINGS";

// Email Notifications

export const GetEmailNotifications = "GET_EMAIL_NOTIFICATIONS";
export const GetEmailNotificationsSuccess = "GET_EMAIL_NOTIFICATIONS_SUCCESS";
export const GetEmailNotificationsError = "GET_EMAIL_NOTIFICATIONS_ERROR";
export const GetEmailNotification = "GET_EMAIL_NOTIFICATION";
export const GetEmailNotificationSuccess = "GET_EMAIL_NOTIFICATION_SUCCESS";
export const GetEmailNotificationError = "GET_EMAIL_NOTIFICATION_ERROR";
export const GetEmailNotificationAssignments = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS";
export const GetEmailNotificationAssignmentsSuccess = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS_SUCCESS";
export const GetEmailNotificationAssignmentsError = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS_ERROR";

export const AddEmailNotification = "ADD_EMAIL_NOTIFICATION";
export const AddEmailNotificationSuccess = "ADD_EMAIL_NOTIFICATION_SUCCESS";
export const AddEmailNotificationError = "ADD_EMAIL_NOTIFICATION_ERROR";
export const UpdateEmailNotification = "UPDATE_EMAIL_NOTIFICATION";
export const UpdateEmailNotificationSuccess = "UPDATE_EMAIL_NOTIFICATION_SUCCESS";
export const UpdateEmailNotificationError = "UPDATE_EMAIL_NOTIFICATION_ERROR";
export const DeleteEmailNotification = "DELETE_EMAIL_NOTIFICATION";
export const DeleteEmailNotificationSuccess = "DELETE_EMAIL_NOTIFICATION_SUCCESS";
export const DeleteEmailNotificationError = "DELETE_EMAIL_NOTIFICATION_ERROR";

export const GetEmailNotificationSchema = "GET_EMAIL_NOTIFICATION_SCHEMA";
export const GetEmailNotificationSchemaSuccess = "GET_EMAIL_NOTIFICATION_SCHEMA_SUCCESS";
export const GetEmailNotificationSchemaError = "GET_EMAIL_NOTIFICATION_SCHEMA_ERROR";

export const SetCurrentEmailNotification = "SET_CURRENT_EMAIL_NOITIFICATION";
export const SetEditedEmailNotification = "SET_EDITED_EMAIL_NOTIFICATION";
export const SetEmailNotificationAssignments = "SET_EMAIL_NOTIFICATION_ASSIGNMENTTS";

export const SetShowAddEmailNotificationModal = "SET_SHOW_ADD_EMAIL_NOTIFICATION_MODAL";
export const SetShowEditEmailNotificationModal = "SET_SHOW_EDIT_EMAIL_NOTIFICATION_MODAL";
export const SetShowDeleteEmailNotificationModal = "SET_SHOW_DELETE_EMAIL_NOTIFICATION_MODAL";

// Manager Sms Settings

export const GetManagerSmsNotificationSettings = "GET_MANAGER_SMS_NOTIFICATION_SETTINGS";
export const GetManagerSmsNotificationSettingsSuccess =
  "GET_MANAGER_SMS_NOTIFICATION_SETTINGS_SUCCESS";
export const GetManagerSmsNotificationSettingsError = "GET_MANAGER_SMS_NOTIFICATION_SETTINGS_ERROR";
export const UpdateManagerSmsNotificationSettings = "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS";
export const UpdateManagerSmsNotificationSettingsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS_SUCCESS";
export const UpdateManagerSmsNotificationSettingsError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS_ERROR";

export const SetManagerSmsNotificationCurrent = "SET_MANAGER_SMS_NOTIFICATION_CURRENT";
export const SetManagerSmsNotificationAssignments = "SET_MANAGER_SMS_NOTIFICATION_ASSIGNMENTS";

export const SetShowAddManagerSmsNotificationModal = "SHOW_ADD_MANAGER_SMS_NOTIFICATION_MODAL";
export const SetShowEditManagerSmsNotificationModal = "SHOW_EDIT_MANAGER_SMS_NOTIFICATION_MODAL";
export const SetShowDeleteManagerSmsNotificationModal =
  "SHOW_DELETE_MANAGER_SMS_NOTIFICATION_MODAL";

// Manager Sms Notifications SMS

export const GetManagerSmsNotificationsSmsRules = "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES";
export const GetManagerSmsNotificationsSmsRulesSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES_SUCCESS";
export const GetManagerSmsNotificationsSmsRulesError =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES_ERROR";

export const GetManagerSmsNotificationsSmsAssignments =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS";
export const GetManagerSmsNotificationsSmsAssignmentsSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_SUCCESS";
export const GetManagerSmsNotificationsSmsAssignmentsError =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_ERROR";
export const UpdateManagerSmsNotificationsSmsAssignments =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS";
export const UpdateManagerSmsNotificationsSmsAssignmentsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_SUCCESS";
export const UpdateManagerSmsNotificationsSmsAssignmentsError =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_ERROR";

export const AddManagerSmsNotificationSmsRule = "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const AddManagerSmsNotificationSmsRuleSuccess =
  "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const AddManagerSmsNotificationSmsRuleError = "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";
export const UpdateManagerSmsNotificationSmsRule = "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const UpdateManagerSmsNotificationSmsRuleSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const UpdateManagerSmsNotificationSmsRuleError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";
export const DeleteManagerSmsNotificationSmsRule = "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const DeleteManagerSmsNotificationSmsRuleSuccess =
  "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const DeleteManagerSmsNotificationSmsRuleError =
  "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";

// Manager Sms Notifications PAGER

export const GetManagerSmsNotificationsPagerRules = "GET_MANAGER_SMS_NOTIFICATIONS_PAGER";
export const GetManagerSmsNotificationsPagerRulesSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_SUCCESS";
export const GetManagerSmsNotificationsPagerRulesError =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ERROR";

export const GetManagerSmsNotificationsPagerAssignments =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS";
export const GetManagerSmsNotificationsPagerAssignmentsSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_SUCCESS";
export const GetManagerSmsNotificationsPagerAssignmentsError =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_ERROR";
export const UpdateManagerSmsNotificationsPagerAssignments =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS";
export const UpdateManagerSmsNotificationsPagerAssignmentsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_SUCCESS";
export const UpdateManagerSmsNotificationsPagerAssignmentsError =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_ERROR";

export const AddManagerSmsNotificationPagerRule = "ADD_MANAGER_SMS_NOTIFICATION_PAGER";
export const AddManagerSmsNotificationPagerRuleSuccess =
  "ADD_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const AddManagerSmsNotificationPagerRuleError = "ADD_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";
export const UpdateManagerSmsNotificationPagerRule = "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER";
export const UpdateManagerSmsNotificationPagerRuleSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const UpdateManagerSmsNotificationPagerRuleError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";
export const DeleteManagerSmsNotificationPagerRule = "DELETE_MANAGER_SMS_NOTIFICATION_PAGER";
export const DeleteManagerSmsNotificationPagerRuleSuccess =
  "DELETE_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const DeleteManagerSmsNotificationPagerRuleError =
  "DELETE_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";

// Employee Sms Notifications

export const GetEmployeeSmsSettings = "GET_EMPLOYEE_SMS_SETTINGS";
export const GetEmployeeSmsSettingsSuccess = "GET_EMPLOYEE_SMS_SETTINGS_SUCCESS";
export const GetEmployeeSmsSettingsError = "GET_EMPLOYEE_SMS_SETTINGS_ERROR";
export const UpdateEmployeeSmsSettings = "UPDATE_EMPLOYEE_SMS_SETTINGS";
export const UpdateEmployeeSmsSettingsSuccess = "UPDATE_EMPLOYEE_SMS_SETTINGS_SUCCESS";
export const UpdateEmployeeSmsSettingsError = "UPDATE_EMPLOYEE_SMS_SETTINGS_ERROR";

export const GetEmployeeSmsRules = "GET_EMPLOYEE_SMS_RULES";
export const GetEmployeeSmsRulesSuccess = "GET_EMPLOYEE_SMS_RULES_SUCCESS";
export const GetEmployeeSmsRulesError = "GET_EMPLOYEE_SMS_RULES_ERROR";
export const AddEmployeeSmsRule = "ADD_EMPLOYEE_SMS_RULE";
export const AddEmployeeSmsRuleSuccess = "ADD_EMPLOYEE_SMS_RULE_SUCCESS";
export const AddEmployeeSmsRuleError = "ADD_EMPLOYEE_SMS_RULE_ERROR";
export const UpdateEmployeeSmsRule = "UPDATE_EMPLOYEE_SMS_RULE";
export const UpdateEmployeeSmsRuleSuccess = "UPDATE_EMPLOYEE_SMS_RULE_SUCCESS";
export const UpdateEmployeeSmsRuleError = "UPDATE_EMPLOYEE_SMS_RULE_ERROR";
export const DeleteEmployeeSmsRule = "DELETE_EMPLOYEE_SMS_RULE";
export const DeleteEmployeeSmsRuleSuccess = "DELETE_EMPLOYEE_SMS_RULE_SUCCESS";
export const DeleteEmployeeSmsRuleError = "DELETE_EMPLOYEE_SMS_RULE_ERROR";
export const GetEmployeeSmsAssignments = "GET_EMPLOYEE_SMS_ASSIGNMENTS";
export const GetEmployeeSmsAssignmentsSuccess = "GET_EMPLOYEE_SMS_ASSIGNMENTS_SUCCESS";
export const GetEmployeeSmsAssignmentsError = "GET_EMPLOYEE_SMS_ASSIGNMENTS_ERROR";

export const GetEmployeeSmsSchema = "GET_EMPLOYEE_SMS_SCHEMA";
export const GetEmployeeSmsSchemaSuccess = "GET_EMPLOYEE_SMS_SCHEMA_SUCCESS";
export const GetEmployeeSmsSchemaError = "GET_EMPLOYEE_SMS_SCHEMA_ERROR";
export const SetEmployeeSmsCurrent = "SET_EMPLOYEE_SMS_CURRENT";
export const SetEmployeeSmsAssignments = "SET_EMPLOYEE_SMS_ASSIGNMENTS";

export const SetShowAddEmployeeSmsModal = "SHOW_ADD_EMPLOYEE_SMS_MODAL";
export const SetShowEditEmployeeSmsModal = "SHOW_EDIT_EMPLOYEE_SMS_MODAL";
export const SetShowDeleteEmployeeSmsModal = "SHOW_DELETE_EMPLOYEE_SMS_MODAL";

// Shift Patterns
export const GetShiftPatterns = "GET_SHIFT_PATTERNS";
export const GetShiftPatternsSuccess = "GET_SHIFT_PATTERNS_SUCCESS";
export const GetShiftPatternsError = "GET_SHIFT_PATTERNS_ERROR";
export const GetTotalShiftPatterns = "GET_TOTAL_SHIFT_PATTERNS";
export const GetTotalShiftPatternsSuccess = "GET_TOTAL_SHIFT_PATTERNS_SUCCESS";
export const GetTotalShiftPatternsError = "GET_TOTAL_SHIFT_PATTERNS_ERROR";
export const NewShiftPattern = "NEW_SHIFT_PATTERN";
export const SetShiftPattern = "SET_SHIFT_PATTERN";
export const AddShiftPattern = "ADD_SHIFT_PATTERN";
export const AddShiftPatternSuccess = "ADD_SHIFT_PATTERN_SUCCESS";
export const AddShiftPatternError = "ADD_SHIFT_PATTERN_ERROR";
export const UpdateShiftPattern = "UPDATE_SHIFT_PATTERN";
export const UpdateShiftPatternSuccess = "UPDATE_SHIFT_PATTERN_SUCCESS";
export const UpdateShiftPatternError = "UPDATE_SHIFT_PATTERN_ERROR";
export const DeleteShiftPattern = "DELETE_SHIFT_PATTERN";
export const DeleteShiftPatternSuccess = "DELETE_SHIFT_PATTERN_SUCCESS";
export const DeleteShiftPatternError = "DELETE_SHIFT_PATTERN_ERROR";
export const ShowAddShiftPatternModal = "SHOW_ADD_SHIFT_PATTERN_MODAL";
export const ShowEditShiftPatternModal = "SHOW_EDIT_SHIFT_PATTERN_MODAL";
export const ShowDeleteShiftPatternModal = "SHOW_DELETE_SHIFT_PATTERN_MODAL";
export const UpdateShiftPatternDraft = "UPDATE_SHIFT_PATTERN_DRAFT";
export const ToggleUnassignReassignShiftPatternModal =
  "TOGGLE_UNASSIGN_REASSIGN_SHIFT_PATTERN_MODAL";
export const GetEmployeePositionsAssignedToShiftPattern =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN";
export const GetEmployeePositionsAssignedToShiftPatternSuccess =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN_SUCCESS";
export const GetEmployeePositionsAssignedToShiftPatternError =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN_ERROR";
export const ToggleUnassignReassignItemsToShiftPatternModal =
  "TOGGLE_UNASSIGN_REASSIGN_ITEMS_TO_SHIFT_PATTERN_MODAL";
export const UnassignReassignItemsShiftPattern = "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN";
export const UnassignReassignItemsShiftPatternSuccess =
  "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN_SUCCESS";
export const UnassignReassignItemsShiftPatternError = "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN_ERROR";
export const GetDepartmentsAssignedToShiftPattern = "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN";
export const GetDepartmentsAssignedToShiftPatternSuccess =
  "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN_SUCCESS";
export const GetDepartmentsAssignedToShiftPatternError =
  "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN_ERROR";

//Staff Groups
export const ToggleDisableStaffGroupModal = "TOGGLE_DISABLE_STAFF_GROOUP_MODAL";
export const UpdateStaffGroup = "UPDATE_STAFF_GROUP";
export const UpdateStaffGroupError = "UPDATE_STAFF_GROUP_ERROR";
export const ReassignStaffGroup = "REASSIGN_STAFF_GROUP";
export const EnableStaffGroup = "ENABLE_STAFF_GROUP";
export const EnableStaffGroupError = "ENABLE_STAFF_GROUP_ERROR";
export const GetStaffGroups = "GET_STAFF_GROUPS";
export const ToggleReassignStaffGroupModal = "TOGGLE_REASSIGN_STAFF_GROUP_MODAL";
export const GetStaffGroupsSuccess = "GET_STAFF_GROUPS_SUCCESS";
export const GetStaffGroupsError = "GET_STAFF_GROUPS_ERROR";
export const SetStaffGroupSchema = "SET_STAFF_GROUP_SCHEMA";
export const GetTotalStaffGroups = "GET_TOTAL_STUFF_GROUPS";
export const GetTotalStaffGroupsSuccess = "GET_TOTAL_STUFF_GROUPS_SUCCESS";
export const GetTotalStaffGroupsError = "GET_TOTAL_STUFF_GROUPS_ERROR";
export const ToggleAddStaffGroupModal = "TOGGLE_ADD_STAFF_GROUP_MODAL";
export const AddStaffGroup = "ADD_STAFF GROUP";
export const GetAddStaffGroupError = "GET_ADD_STAFF_GROUP_ERROR";
export const ToggleEditStaffGroupModal = "TOGGLE_EDIT_STAFF_GROUP_MODAL";
export const EditStaffGroup = "EDIT_STAFF_GROUP";
export const GetStaffGroupsSchema = "GET_STAFF_GROUPS_SCHEMA";
export const SetStaffGroupsSchema = "SET_STAFF_GROUPS_SCHEMA";
export const SaveStaffGroupConfiguration = "SAVE_STAFF_GROUP_CONFIGURATION";
export const GetStaffGroupsConfiguration = "GET_STAFF_GROUPS_CONFIGURATION";
export const GetStaffGroupsConfigurationSuccess = "GET_STAFF_GROUPS_CONFIGURATION_SUCCESS";
export const ToggleEnableStaffGroupModal = "TOGGLE_ENABLE_STAFF_GROUP_MODAL";
export const SetStaffGroupsSort = "SET_STAFF_GROUPS_SORT";
export const ShowReassignStaffGroupModal = "SHOW_REASSIGN_STAFF_GROUP_MODAL";

export const DismissAddNurseDeclinedReason = "DISMISS_ADD_NURSE_DECLINED_REASON";
export const ToggleAddShiftModal = "TOGGLE_ADD_SHIFT_MODAL";
export const ToggleUpdateShiftModal = "TOGGLE_UPDATE_SHIFT_MODAL";
export const GetDataSecuritySettings = "GET_DATA_SECURITY_SETTINGS";
export const GetDataSecuritySettingsSuccess = "GET_DATA_SECURITY_SETTINGS_SUCCESS";
export const GetDataSecuritySettingsError = "GET_DATA_SECURITY_SETTINGS_ERROR";
export const UpdateDataSecuritySettings = "UPDATE_DATA_SECURITY_SETTINGS";
export const UpdateDataSecuritySettingsSuccess = "UPDATE_DATA_SECURITY_SETTINGS_SUCCESS";
export const UpdateDataSecuritySettingsError = "UPDATE_DATA_SECURITY_SETTINGS_ERROR";
export const GetEmployeeSchemaSuccess = "GET_EMPLOYEE_SCHEMA_SUCCESS";
export const GetEmployeeSchemaError = "GET_EMPLOYEE_SCHEMA_ERROR";
export const GetEmployeeSecuritySchema = "GET_EMPLOYEE_SECURITY_SCHEMA";
export const GetEmployeeSecuritySchemaSuccess = "GET_EMPLOYEE_SECURITY_SCHEMA_SUCCESS";
export const GetEmployeeSecuritySchemaError = "GET_EMPLOYEE_SECURITY_SCHEMA_ERROR";

// System Access
export const GetDataSecurityGeneralSettings = "GET_DATA_SECURITY_GENERAL_SETTINGS";
export const GetDataSecurityGeneralSettingsSuccess = "GET_DATA_SECURITY_GENERAL_SETTINGS_SUCCESS";
export const GetDataSecurityGeneralSettingsError = "GET_DATA_SECURITY_GENERAL_SETTINGS_ERROR";
export const ToggleSystemAccessPasswordResetModal = "TOGGLE_SYSTEM_ACCESS_PASSWORD_RESET_MODAL";
export const ToggleSystemAccessLogOutLockModal = "TOGGLE_SYSTEM_ACCESS_LOG_OUT_LOCK_MODAL";
export const ToggleAddIpRestrictionModal = "TOGGLE_ADD_IP_RESTRICTION_MODAL";
export const UpdateDataSecurityGeneralSettings = "UPDATE_DATA_SECURITY_GENERAL_SETTINGS";
export const UpdateDataSecurityGeneralSettingsSuccess =
  "UPDATE_DATA_SECURITY_GENERAL_SETTINGS_SUCCESS";
export const UpdateDataSecurityGeneralSettingsError = "UPDATE_DATA_SECURITY_GENERAL_SETTINGS_ERROR";
export const GetClientLogo = "GET_CLIENT_LOGO";
export const GetClientLogoSuccess = "GET_CLIENT_LOGO_SUCCESS";
export const GetClientLogoError = "GET_CLIENT_LOGO_ERROR";
export const UploadClientLogo = "UPLOAD_CLIENT_LOGO";
export const UploadClientLogoSuccess = "UPLOAD_CLIENT_LOGO_SUCCESS";
export const UploadClientLogoError = "UPLOAD_CLIENT_LOGO_ERROR";
export const ToggleClientLogoModal = "TOGGLE_CLIENT_LOGO_MODAL";
export const ToggleRegistrationEmailsModal = "TOGGLE_REGISTRATION_EMAILS_MODAL";
export const ToggleEmployeeRegistrationEmailsModal = "TOGGLE_EMPLOYEE_REGISTRATION_EMAILS_MODAL";
export const ToggleRegistrationEmailsExportModal = "TOGGLE_REGISTRATION_EMAILS_EXPORT_MODAL";
export const SendBulkRegistrationEmails = "SEND_BULK_REGISTRATION_EMAILS";
export const SendBulkRegistrationEmailsSuccess = "SEND_BULK_REGISTRATION_EMAILS_SUCCESS";
export const SendBulkRegistrationEmailsError = "SEND_BULK_REGISTRATION_EMAILS_ERROR";
export const SendEmployeeRegistrationEmails = "SEND_EMPLOYEE_REGISTRATION_EMAILS";
export const SendEmployeeRegistrationEmailsSuccess = "SEND_EMPLOYEE_REGISTRATION_EMAILS_SUCCESS";
export const SendEmployeeRegistrationEmailsError = "SEND_EMPLOYEE_REGISTRATION_EMAILS_ERROR";
export const GetPasswordPolicy = "GET_PASSORD_POLICY";
export const GetPasswordPolicySuccess = "GET_PASSORD_POLICY_SUCCESS";
export const GetPasswordPolicyError = "GET_PASSORD_POLICY_ERROR";
export const GetBulkRegistrationEmails = "GET_BULK_REGISTRATION_EMAILS";
export const GetBulkRegistrationEmailsSuccess = "GET_BULK_REGISTRATION_EMAILS_SUCCESS";
export const GetBulkRegistrationEmailsError = "GET_BULK_REGISTRATION_EMAILS_ERROR";
export const GetBulkRegistrationEmailsTargets = "GET_BULK_REGISTRATION_EMAILS_TARGETS";
export const GetBulkRegistrationEmailsTargetsSuccess =
  "GET_BULK_REGISTRATION_EMAILS_TARGETS_SUCCESS";
export const GetBulkRegistrationEmailsTargetsError = "GET_BULK_REGISTRATION_EMAILS_TARGETS_ERROR";
export const GetEmployeeRegistrationEmailsTargets = "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS";
export const GetEmployeeRegistrationEmailsTargetsSuccess =
  "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS_SUCCESS";
export const GetEmployeeRegistrationEmailsTargetsError =
  "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS_ERROR";
export const GetPlatformDataSecurity = "GET_PLATFORM_DATA_SECURITY";
export const GetPlatformDataSecuritySuccess = "GET_PLATFORM_DATA_SECURITY_SUCCESS";
export const GetPlatformDataSecurityError = "GET_PLATFORM_DATA_SECURITY_ERROR";
export const ToggleStandardRegistrationEmailsModal = "TOGGLE_STANDARD_REGISTRATION_EMAILS_MODAL";
export const UpdateRegistrationEmails = "UPDATE_REGISTRATION_EMAILS";
export const UpdateRegistrationEmailsSuccess = "UPDATE_REGISTRATION_EMAILS_SUCCESS";
export const UpdateRegistrationEmailsError = "UPDATE_REGISTRATION_EMAILS_ERROR";
export const ExportBulkRegistrationEmails = "EXPORT_BULK_REGISTRATION_EMAILS";
export const ExportBulkRegistrationEmailsSuccess = "EXPORT_BULK_REGISTRATION_EMAILS_SUCCESS";
export const ExportBulkRegistrationEmailsError = "EXPORT_BULK_REGISTRATION_EMAILS_ERROR";
export const ToggleConfirmEnableMfaModal = "TOGGLE_CONFIRM_ENABLE_MFA_MODAL";

// Email Controls
export const GetEmailControlsSettings = "GET_EMAIL_CONTROLS_SETTINGS";
export const GetEmailControlsSettingsSuccess = "GET_EMAIL_CONTROLS_SETTINGS_SUCCESS";
export const GetEmailControlsSettingsError = "GET_EMAIL_CONTROLS_SETTINGS_ERROR";
export const UpdateEmailControlsSettings = "UPDATE_EMAIL_CONTROLS_SETTINGS";
export const UpdateEmailControlsSettingsSuccess = "UPDATE_EMAIL_CONTROLS_SETTINGS_SUCCESS";
export const UpdateEmailControlsSettingsError = "UPDATE_EMAIL_CONTROLS_SETTINGS_ERROR";
export const ToggleAddEmailDomainModal = "TOGGLE_ADD_EMAIL_DOMAIN_MODAL";

// Manager Self-Service
export const GetManagerSelfServiceSettings = "GET_MANAGER_SELF_SERVICE_SETTINGS";
export const GetManagerSelfServiceSettingsSuccess = "GET_MANAGER_SELF_SERVICE_SETTINGS_SUCCESS";
export const GetManagerSelfServiceSettingsError = "GET_MANAGER_SELF_SERVICE_SETTINGS_ERROR";
export const UpdateManagerSelfServiceSettings = "UPDATE_MANAGER_SELF_SERVICE_SETTINGS";
export const UpdateManagerSelfServiceSettingsSuccess =
  "UPDATE_MANAGER_SELF_SERVICE_SETTINGS_SUCCESS";
export const UpdateManagerSelfServiceSettingsError = "UPDATE_MANAGER_SELF_SERVICE_SETTINGS_ERROR";

// Nurse Declined Reasons
export const GetNurseDeclinedReasonsList = "GET_NURSE_DECLINED_REASONS_LIST";
export const GetNurseDeclinedReasonsListSuccess = "GET_NURSE_DECLINED_REASON_LISTS_SUCCESS";
export const GetNurseDeclinedReasonsListError = "GET_NURSE_DECLINED_REASON_LISTS_ERROR";
export const GetNurseDeclinedReason = "GET_NURSE_DECLINED_REASON";
export const GetNurseDeclinedReasonSuccess = "GET_NURSE_DECLINED_REASON_SUCCESS";
export const GetNurseDeclinedReasonError = "GET_NURSE_DECLINED_REASON_ERROR";
export const ResetNurseDeclinedReason = "RESET_NURSE_DECLINED_REASON";
export const GetNurseDeclinedReasonSchema = "GET_NURSE_DECLINED_REASON_SCHEMA";
export const GetNurseDeclinedReasonSchemaSuccess = "GET_NURSE_DECLINED_REASON_SCHEMA_SUCCESS";
export const GetNurseDeclinedReasonSchemaError = "GET_NURSE_DECLINED_REASON_SCHEMA_ERROR";

export const AddNurseDeclinedReason = "ADD_NURSE_DECLINED_REASON";
export const AddNurseDeclinedReasonSuccess = "ADD_NURSE_DECLINED_REASON_SUCCESS";
export const AddNurseDeclinedReasonError = "ADD_NURSE_DECLINED_REASON_ERROR";
export const UpdateNurseDeclinedReason = "UPDATE_NURSE_DECLINED_REASON";
export const UpdateNurseDeclinedReasonSuccess = "UPDATE_NURSE_DECLINED_REASON_SUCCESS";
export const UpdateNurseDeclinedReasonError = "UPDATE_NURSE_DECLINED_REASON_ERROR";

export const SetNurseDeclinedReasonsEnabled = "SET_SHOW_NURSE_DECLINED_REASONS_ENABLED";
export const SetNurseDeclinedReasonsStatus = "SET_SHOW_NURSE_DECLINED_REASONS_STATUS";
export const SetShowAddNurseDeclinedReasonModal = "SET_SHOW_NURSE_DECLINED_REASON_ADD_MODAL";
export const SetShowEditNurseDeclinedReasonModal = "SET_SHOW_NURSE_DECLINED_REASON_EDIT_MODAL";

// EAP Signposting
export const GetWellbeingServicesList = "GET_WELLBEING_SERVICES_LIST";
export const GetWellbeingServicesListSuccess = "GET_WELLBEING_SERVICES_LIST_SUCCESS";
export const GetWellbeingServicesListError = "GET_WELLBEING_SERVICES_LIST_ERROR";

export const GetWellbeingServiceDetails = "GET_WELLBEING_SERVICE_DETAILS";
export const GetWellbeingServiceDetailsSuccess = "GET_WELLBEING_SERVICE_DETAILS_SUCCESS";
export const GetWellbeingServiceDetailsError = "GET_WELLBEING_SERVICE_DETAILS_ERROR";

export const AddWellbeingService = "ADD_WELLBEING_SERVICE";
export const AddWellbeingServiceSuccess = "ADD_WELLBEING_SERVICE_SUCCESS";
export const AddWellbeingServiceError = "ADD_WELLBEING_SERVICE_ERROR";

export const EditWellbeingService = "EDIT_WELLBEING_SERVICE";
export const EditWellbeingServiceSuccess = "EDIT_WELLBEING_SERVICE_SUCCESS";
export const EditWellbeingServiceError = "EDIT_WELLBEING_SERVICE_ERROR";

export const SetWellbeingServiceCurrentDetails = "SET_WELLBEING_SERVICE_CURRENT_DETAILS";
export const SetWellbeingServiceDraft = "SET_WELLBEING_SERVICE_DRAFT";
export const SetWellbeingServiceSchema = "SET_WELLBEING_SERVICE_SCHEMA";

export const SetShowAddWellbeingServiceModal = "SET_SHOW_ADD_WELLBEING_SERVICE_MODAL";
export const SetShowEditWellbeingServiceModal = "SET_SHOW_EDIT_WELLBEING_SERVICE_MODAL";

/////////
export const ShowEditAssignmentsModal = "SHOW_EDIT_ASSIGNMENTS_MODAL";

export const NewWellbeingServiceAssignments = "NEW_WELLBEING_SERVICE_ASSIGNMENTS";
export const SetWellbeingServiceAssignments = "SET_WELLBEING_SERVICE_ASSIGNMENTS";
export const SetWellbeingServiceDraftAssignments = "SET_WELLBEING_SERVICE_DRAFT_ASSIGNMENTS";
//
export const EditWellbeingServiceAssignments = "EDIT_WELLBEING_SERVICE_ASSIGNMENTS";
export const EditWellbeingServiceAssignmentsSuccess = "EDIT_WELLBEING_SERVICE_ASSIGNMENTS_SUCCESS";
export const EditWellbeingServiceAssignmentsError = "EDIT_WELLBEING_SERVICE_ASSIGNMENTS_ERROR";
//
// Absence Reasons
export const GetAbsenceReasonsList = "GET_ABSENCE_REASONS_LIST";
export const GetAbsenceReasonsListSuccess = "GET_ABSENCE_REASONS_LIST_SUCCESS";
export const GetAbsenceReasonsListError = "GET_ABSENCE_REASONS_LIST_ERROR";
export const ShowAddAbsenceReasonModal = "SHOW_ADD_ABSENCE_REASON_MODAL";
export const NewAbsenceReason = "NEW_ABSENCE_REASON";
export const UpdateAbsenceReasonDraft = "UPDATE_ABSENCE_REASON_DRAFT";
export const GetAbsenceReasonActiveSuccess = "GET_ABSENCE_REASON_ACTIVE_SUCCESS";
export const AddNewAbsenceReason = "ADD_NEW_ABSENCE_REASON";
export const AddNewAbsenceReasonSuccess = "ADD_NEW_ABSENCE_REASON_SUCCESS";
export const AddNewAbsenceReasonError = "ADD_NEW_ABSENCE_REASON_ERROR";
export const SetAbsenceReasonAssignments = "SET_ABSENCE_REASON_ASSIGNMENTS";
export const GetAbsenceReason = "GET_ABSENCE_REASON";
export const GetAbsenceReasonSuccess = "GET_ABSENCE_REASON_SUCCESS";
export const GetAbsenceReasonError = "GET_ABSENCE_REASON_ERROR";
export const ResetAbsenceReason = "RESET_ABSENCE_REASON";
export const ShowAbsenceReasonEditModal = "SHOW_ABSENCE_REASON_EDIT_MODAL";
export const UpdateAbsenceReason = "UPDATE_ABSENCE_REASON";
export const UpdateAbsenceReasonSuccess = "UPDATE_ABSENCE_REASON_SUCCESS";
export const UpdateAbsenceReasonError = "UPDATE_ABSENCE_REASON_ERROR";
export const UpdateAbsenceReasonAssignments = "UPDATE_ABSENCE_REASON_ASSIGNMENTS";
export const UpdateAbsenceReasonAssignmentsError = "UPDATE_ABSENCE_REASON_ASSIGNMENTS_ERROR";
export const SetAbsenceReasonsShowEditModal = "SET_ABSENCE_REASONS_SHOW_EDIT_MODAL";
export const ChangeAbsenceReasonsFilterState = "CHANGE_ABSENCE_REASONS_FILTER_STATE";
export const ChangeAbsenceReasonsFilterType = "CHANGE_ABSENCE_REASONS_FILTER_TYPE";
export const ExportLiveAbsenceReasons = "EXPORT_LIVE_ABSENCE_REASONS";
export const ExportLiveAbsenceReasonsSuccess = "EXPORT_LIVE_ABSENCE_REASONS_SUCCESS";
export const ExportLiveAbsenceReasonsError = "EXPORT_LIVE_ABSENCE_REASONS_ERROR";
export const GetAbsenceReasonSchema = "GET_ABSENCE_REASON_SCHEMA";
export const GetAbsenceReasonSchemaSuccess = "GET_ABSENCE_REASON_SCHEMA_SUCCESS";
export const GetAbsenceReasonSchemaError = "GET_ABSENCE_REASON_SCHEMA_ERROR";

// Absence Audit Logs
export const GetAbsenceAuditLogs = "GET_ABSENCE_AUDIT_LOGS";
export const GetAbsenceAuditLogsSuccess = "GET_ABSENCE_AUDIT_SUCCESS";
export const GetAbsenceAuditLogsError = "GET_ABSENCE_AUDIT_ERROR";
export const ExportAbsenceAuditLogs = "EXPORT_ABSENCE_AUDIT_LOGS";
export const ExportAbsenceAuditLogsSuccess = "EXPORT_ABSENCE_AUDIT_SUCCESS";
export const ExportAbsenceAuditLogsError = "EXPORT_ABSENCE_AUDIT_ERROR";
// Notification Audit Logs
export const GetNotificationAuditLogs = "GET_NOTIFICATION_AUDIT_LOGS";
export const GetNotificationAuditLogsSuccess = "GET_NOTIFICATION_AUDIT_SUCCESS";
export const GetNotificationAuditLogsError = "GET_NOTIFICATION_AUDIT_ERROR";
export const ExportNotificationAuditLogs = "EXPORT_NOTIFICATION_AUDIT_LOGS";
export const ExportNotificationAuditLogsSuccess = "EXPORT_NOTIFICATION_AUDIT_SUCCESS";
export const ExportNotificationAuditLogsError = "EXPORT_NOTIFICATION_AUDIT_ERROR";
// Absence Access Audit Logs
export const GetAbsenceAccessAuditLogs = "GET_ABSENCE_ACCESS_AUDIT_LOGS";
export const GetAbsenceAccessAuditLogsSuccess = "GET_ABSENCE_ACCESS_AUDIT_SUCCESS";
export const GetAbsenceAccessAuditLogsError = "GET_ABSENCE_ACCESS_AUDIT_ERROR";
export const ExportAbsenceAccessAuditLogs = "EXPORT_ABSENCE_ACCESS_AUDIT_LOGS";
export const ExportAbsenceAccessAuditLogsSuccess = "EXPORT_ABSENCE_ACCESS_AUDIT_SUCCESS";
export const ExportAbsenceAccessAuditLogsError = "EXPORT_ABSENCE_ACCESS_AUDIT_ERROR";

export const GetAuditLogsReset = "GET_AUDIT_LOGS_RESET";

// Alerts
export const GetAlertsList = "GET_ALERTS_LIST";
export const GetAlertsListSuccess = "GET_ALERT_LISTS_SUCCESS";
export const GetAlertsListError = "GET_ALERT_LISTS_ERROR";
export const GetAlert = "GET_ALERT";
export const GetAlertSuccess = "GET_ALERT_SUCCESS";
export const GetAlertError = "GET_ALERT_ERROR";
export const GetAlertSchema = "GET_ALERT_SCHEMA";
export const GetAlertSchemaSuccess = "GET_ALERT_SCHEMA_SUCCESS";
export const GetAlertSchemaError = "GET_ALERT_SCHEMA_ERROR";

export const NewAlert = "NEW_ALERT";
export const StartDraftAlert = "START_ALERT_DRAFT";
export const StartDraftAlertSuccess = "START_ALERT_DRAFT_SUCCESS";
export const StartDraftAlertError = "START_ALERT_DRAFT_ERROR";
export const SetAlertDraft = "UPDATE_ALERT_DRAFT";
export const NewAlertAssignments = "NEW_ALERT_ASSIGNMENTS";
export const SetAlertAssignments = "SET_ALERT_ASSIGNMENTS";
export const SetAlertDraftAssignments = "SET_ALERT_DRAFT_ASSIGNMENTS";

export const AddAlert = "ADD_ALERT";
export const AddAlertSuccess = "ADD_ALERT_SUCCESS";
export const AddAlertError = "ADD_ALERT_ERROR";
export const UpdateAlert = "UPDATE_ALERT";
export const UpdateAlertSuccess = "UPDATE_ALERT_SUCCESS";
export const UpdateAlertError = "UPDATE_ALERT_ERROR";
export const DeleteBespokeRecipient = "DELETE_BESPOKE_RECIPIENT";
export const UpdateRecipientAssignments = "UPDATE_RECIPIENT_ASSIGNMENTS";
export const UpdateRecipientAssignmentsSuccess = "UPDATE_RECIPIENT_ASSIGNMENTS_SUCCESS";
export const UpdateRecipientAssignmentsError = "UPDATE_RECIPIENT_ASSIGNMENTS_ERROR";
export const UpdateAlertAssignments = "UPDATE_ALERT_ASSIGNMENTS";
export const UpdateAlertAssignmentsSuccess = "UPDATE_ALERT_ASSIGNMENTS_SUCCESS";
export const UpdateAlertAssignmentsError = "UPDATE_ALERT_ASSIGNMENTS_ERROR";
export const AddAlertAttachment = "ADD_ALERT_ATTACHMENT";
export const AddAlertAttachmentSuccess = "ADD_ALERT_ATTACHMENT_SUCCESS";
export const AddAlertAttachmentError = "ADD_ALERT_ATTACHMENT_ERROR";
export const DeleteAlertAttachment = "DELETE_ALERT_ATTACHMENT";
export const DeleteAlertAttachmentSuccess = "DELETE_ALERT_ATTACHMENT_SUCCESS";
export const DeleteAlertAttachmentError = "DELETE_ALERT_ATTACHMENT_ERROR";
export const DownloadAlertAttachment = "DOWNLOAD_ALERT_ATTACHMENT";
export const DownloadAlertAttachmentSuccess = "DOWNLOAD_ALERT_ATTACHMENT_SUCCESS";
export const DownloadAlertAttachmentError = "DOWNLOAD_ALERT_ATTACHMENT_ERROR";

export const DisableAlert = "DISABLE_ALERT";
export const DisableAlertSuccess = "DISABLE_ALERT_SUCCESS";
export const DisableAlertError = "DISABLE_ALERT_ERROR";

export const SetShowAddAlertRecipientModal = "SET_SHOW_ADD_ALERT_RECIPIENT_MODAL";
export const SetShowAddAlertAttachmentModal = "SET_SHOW_ADD_ALERT_ATTACHMENT_MODAL";
export const SetShowDeleteAlertAttachmentModal = "SET_SHOW_DELETE_ALERT_ATTACHMENT_MODAL";

export const ResetAlertsState = "RESET_ALERTS_STATE";

// Referrals
export const GetReferralList = "GET_REFERRAL_LIST";
export const GetReferralListSuccess = "GET_REFERRAL_LISTS_SUCCESS";
export const GetReferralListError = "GET_REFERRAL_LISTS_ERROR";
export const GetReferral = "GET_REFERRAL";
export const GetReferralSuccess = "GET_REFERRAL_SUCCESS";
export const GetReferralError = "GET_REFERRAL_ERROR";
export const GetReferralSchema = "GET_REFERRAL_SCHEMA";
export const GetReferralSchemaSuccess = "GET_REFERRAL_SCHEMA_SUCCESS";
export const GetReferralSchemaError = "GET_REFERRAL_SCHEMA_ERROR";

export const NewReferral = "NEW_REFERRAL";
export const StartDraftReferral = "START_REFERRAL_DRAFT";
export const StartDraftReferralSuccess = "START_REFERRAL_DRAFT_SUCCESS";
export const StartDraftReferralError = "START_REFERRAL_DRAFT_ERROR";
export const SetReferralDraft = "UPDATE_REFERRAL_DRAFT";
export const NewReferralAssignments = "NEW_REFERRAL_ASSIGNMENTS";
export const SetReferralAssignments = "SET_REFERRAL_ASSIGNMENTS";

export const AddReferral = "ADD_REFERRAL";
export const AddReferralSuccess = "ADD_REFERRAL_SUCCESS";
export const AddReferralError = "ADD_REFERRAL_ERROR";
export const UpdateReferral = "UPDATE_REFERRAL";
export const UpdateReferralSuccess = "UPDATE_REFERRAL_SUCCESS";
export const UpdateReferralError = "UPDATE_REFERRAL_ERROR";
export const UpdateReferralAssignments = "UPDATE_REFERRAL_ASSIGNMENTS";
export const UpdateReferralAssignmentsSuccess = "UPDATE_REFERRAL_ASSIGNMENTS_SUCCESS";
export const UpdateReferralAssignmentsError = "UPDATE_REFERRAL_ASSIGNMENTS_ERROR";
export const AddReferralAttachment = "ADD_REFERRAL_ATTACHMENT";
export const AddReferralAttachmentSuccess = "ADD_REFERRAL_ATTACHMENT_SUCCESS";
export const AddReferralAttachmentError = "ADD_REFERRAL_ATTACHMENT_ERROR";
export const DeleteReferralAttachment = "DELETE_REFERRAL_ATTACHMENT";
export const DeleteReferralAttachmentSuccess = "DELETE_REFERRAL_ATTACHMENT_SUCCESS";
export const DeleteReferralAttachmentError = "DELETE_REFERRAL_ATTACHMENT_ERROR";

// Return to Work (RTW)
export const GetRtwProcesses = "GET_RTW_PROCESSES";
export const GetRtwProcessesSuccess = "GET_RTW_PROCESSES_SUCCESS";
export const GetRtwProcessesError = "GET_RTW_PROCESSES_ERROR";

export const SetRTWLiveProcessesFilter = "SET_RTWLIVE_PROCESSES_FILTER";

export const GetRtw = "GET_RTW";
export const GetRtwSuccess = "GET_RTW_SUCCESS";
export const GetRtwError = "GET_RTW_ERROR";
export const GetRtwSchema = "GET_RTW_SCHEMA";
export const GetRtwSchemaSuccess = "GET_RTW_SCHEMA_SUCCESS";
export const GetRtwSchemaError = "GET_RTW_SCHEMA_ERROR";

export const NewRtw = "NEW_RTW";
export const StartDraftRtw = "START_RTW_DRAFT";
export const StartDraftRtwSuccess = "START_RTW_DRAFT_SUCCESS";
export const StartDraftRtwError = "START_RTW_DRAFT_ERROR";

export const SetRtwDraft = "SET_RTW_DRAFT";
export const NewRtwAssignments = "NEW_RTW_ASSIGNMENTS";
export const SetRtwAssignments = "SET_RTW_ASSIGNMENTS";
export const SetRtwDraftAssignments = "SET_RTW_DRAFT_ASSIGNMENTS";

export const AddRtw = "ADD_RTW";
export const AddRtwSuccess = "ADD_RTW_SUCCESS";
export const AddRtwError = "ADD_RTW_ERROR";
export const UpdateRtw = "UPDATE_RTW";
export const UpdateRtwSuccess = "UPDATE_RTW_SUCCESS";
export const UpdateRtwError = "UPDATE_RTW_ERROR";
export const UpdateRtwAssignments = "UPDATE_RTW_ASSIGNMENTS";
export const UpdateRtwAssignmentsSuccess = "UPDATE_RTW_ASSIGNMENTS_SUCCESS";
export const UpdateRtwAssignmentsError = "UPDATE_RTW_ASSIGNMENTS_ERROR";
export const AddRtwAttachment = "ADD_RTW_ATTACHMENT";
export const AddRtwAttachmentSuccess = "ADD_RTW_ATTACHMENT_SUCCESS";
export const AddRtwAttachmentError = "ADD_RTW_ATTACHMENT_ERROR";
export const DeleteRtwAttachment = "DELETE_RTW_ATTACHMENT";
export const DeleteRtwAttachmentSuccess = "DELETE_RTW_ATTACHMENT_SUCCESS";
export const DeleteRtwAttachmentError = "DELETE_RTW_ATTACHMENT_ERROR";
export const ResetRtwState = "RESET_RTW_STATE";

export const DisableRtw = "DISABLE_RTW";
export const DisableRtwSuccess = "DISABLE_RTW_SUCCESS";
export const DisableRtwError = "DISABLE_RTW_ERROR";

export const SetRtwEnabled = "SET_RTW_ENABLED";

export const SetShowAddRtwAttachmentModal = "SET_SHOW_ADD_RTW_ATTACHMENT_MODAL";
export const ChangeAddFileInProgress = "CHANGE_ADD_FILE_IN_PROGRESS";

// Absence Monitoring
export const GetAbsenceMonitoringList = "GET_ABSENCE_MONITORING_LIST";
export const GetAbsenceMonitoringListSuccess = "GET_ABSENCE_MONITORING_LISTS_SUCCESS";
export const GetAbsenceMonitoringListError = "GET_ABSENCE_MONITORING_LISTS_ERROR";
export const GetAbsenceMonitoring = "GET_ABSENCE_MONITORING";
export const GetAbsenceMonitoringSuccess = "GET_ABSENCE_MONITORING_SUCCESS";
export const GetAbsenceMonitoringError = "GET_ABSENCE_MONITORING_ERROR";
export const GetAbsenceMonitoringSchema = "GET_ABSENCE_MONITORING_SCHEMA";
export const GetAbsenceMonitoringSchemaSuccess = "GET_ABSENCE_MONITORING_SCHEMA_SUCCESS";
export const GetAbsenceMonitoringSchemaError = "GET_ABSENCE_MONITORING_SCHEMA_ERROR";

export const NewAbsenceMonitoring = "NEW_ABSENCE_MONITORING";
export const SetAbsenceMonitoringDraft = "UPDATE_ABSENCE_MONITORING_DRAFT";
export const NewAbsenceMonitoringAssignments = "NEW_ABSENCE_MONITORING_ASSIGNMENTS";
export const SetAbsenceMonitoringAssignments = "SET_ABSENCE_MONITORING_ASSIGNMENTS";

export const AddAbsenceMonitoring = "ADD_ABSENCE_MONITORING";
export const AddAbsenceMonitoringSuccess = "ADD_ABSENCE_MONITORING_SUCCESS";
export const AddAbsenceMonitoringError = "ADD_ABSENCE_MONITORING_ERROR";
export const UpdateAbsenceMonitoring = "UPDATE_ABSENCE_MONITORING";
export const UpdateAbsenceMonitoringSuccess = "UPDATE_ABSENCE_MONITORING_SUCCESS";
export const UpdateAbsenceMonitoringError = "UPDATE_ABSENCE_MONITORING_ERROR";
export const UpdateAbsenceMonitoringAssignments = "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS";
export const SetAbsenceMonitoringDraftAssignments = "SET_ABSENCE_MONITORING_DRAFT_ASSIGNMENTS";
export const ResetAbsenceMonitoringState = "RESET_ABSENCE_MONITORING_STATE";

export const UpdateAbsenceMonitoringAssignmentsSuccess =
  "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS_SUCCESS";
export const UpdateAbsenceMonitoringAssignmentsError =
  "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS_ERROR";
export const AddAbsenceMonitoringAttachment = "ADD_ABSENCE_MONITORING_ATTACHMENT";
export const AddAbsenceMonitoringAttachmentSuccess = "ADD_ABSENCE_MONITORING_ATTACHMENT_SUCCESS";
export const AddAbsenceMonitoringAttachmentError = "ADD_ABSENCE_MONITORING_ATTACHMENT_ERROR";
export const DeleteAbsenceMonitoringAttachment = "DELETE_ABSENCE_MONITORING_ATTACHMENT";
export const DeleteAbsenceMonitoringAttachmentSuccess =
  "DELETE_ABSENCE_MONITORING_ATTACHMENT_SUCCESS";
export const DeleteAbsenceMonitoringAttachmentError = "DELETE_ABSENCE_MONITORING_ATTACHMENT_ERROR";

export const DisableAbsenceMonitoring = "DISABLE_ABSENCE_MONITORING";
export const DisableAbsenceMonitoringSuccess = "DISABLE_ABSENCE_MONITORING_SUCCESS";
export const DisableAbsenceMonitoringError = "DISABLE_ABSENCE_MONITORING_ERROR";

export const AddNewAppealProcess = "ADD_NEW_APPEAL_PROCESS";
export const AddNewAppealProcessSuccess = "ADD_NEW_APPEAL_PROCESS_SUCCESS";
export const AddNewAppealProcessError = "ADD_NEW_APPEAL_PROCESS_ERROR";
export const UpdateAppealProcess = "UPDATE_APPEAL_PROCESS";
export const UpdateAppealProcessSuccess = "UPDATE_APPEAL_PROCESS_SUCCESS";
export const UpdateAppealProcessError = "UPDATE_APPEAL_PROCESS_ERROR";

// Special Contacts
export const GetSpecialContacts = "GET_SPECIAL_CONTACTS";
export const GetSpecialContactsSuccess = "GET_SPECIAL_CONTACTS_SUCCESS";
export const GetSpecialContactsError = "GET_SPECIAL_CONTACTS_ERROR";
export const GetSpecialContactsEmployees = "GET_SPECIAL_CONTACTS_EMPLOYEES";
export const GetSpecialContactsEmployeesSuccess = "GET_SPECIAL_CONTACTS_EMPLOYEES_SUCCESS";
export const GetSpecialContactsEmployeesError = "GET_SPECIAL_CONTACTS_EMPLOYEES_ERROR";
export const ClearSpecialContactsEmployees = "CLEAR_SPECIAL_CONTACTS_EMPLOYEES";
export const AddSpecialContact = "ADD_SPECIAL_CONTACT";
export const AddSpecialContactSuccess = "ADD_SPECIAL_CONTACT_SUCCESS";
export const AddSpecialContactError = "ADD_SPECIAL_CONTACT_ERROR";
export const UpdateSpecialContact = "UPDATE_SPECIAL_CONTACT";
export const UpdateSpecialContactSuccess = "UPDATE_SPECIAL_CONTACT_SUCCESS";
export const UpdateSpecialContactError = "UPDATE_SPECIAL_CONTACT_ERROR";
export const RemoveSpecialContact = "REMOVE_SPECIAL_CONTACT";
export const RemoveSpecialContactSuccess = "REMOVE_SPECIAL_CONTACT_SUCCESS";
export const RemoveSpecialContactError = "REMOVE_SPECIAL_CONTACT_ERROR";
export const SetSpecialContactsListOptions = "SET_SPECIAL_CONTACTS_LIST_OPTIONS";
export const SetCurrentSpecialContact = "SET_SHOW_CURRENT_SPECIAL_CONTACT";
export const SetShowAddSpecialContactModal = "SHOW_ADD_SPECIAL_CONTACT_MODAL";
export const SetShowEditSpecialContactModal = "SHOW_EDIT_SPECIAL_CONTACT_MODAL";
export const SetShowDeleteSpecialContactModal = "SHOW_DELETE_SPECIAL_CONTACT_MODAL";

// Special Contact Types
export const GetSpecialContactTypes = "GET_SPECIAL_CONTACT_TYPES";
export const GetSpecialContactTypesSuccess = "GET_SPECIAL_CONTACT_TYPES_SUCCESS";
export const GetSpecialContactTypesError = "GET_SPECIAL_CONTACT_TYPES_ERROR";
export const AddSpecialContactType = "ADD_SPECIAL_CONTACT_TYPE";
export const AddSpecialContactTypeSuccess = "ADD_SPECIAL_CONTACT_TYPE_SUCCESS";
export const AddSpecialContactTypeError = "ADD_SPECIAL_CONTACT_TYPE_ERROR";
export const UpdateSpecialContactType = "UPDATE_SPECIAL_CONTACT_TYPE";
export const UpdateSpecialContactTypeSuccess = "UPDATE_SPECIAL_CONTACT_TYPE_SUCCESS";
export const UpdateSpecialContactTypeError = "UPDATE_SPECIAL_CONTACT_TYPE_ERROR";
export const RemoveSpecialContactType = "REMOVE_SPECIAL_CONTACT_TYPE";
export const RemoveSpecialContactTypeSuccess = "REMOVE_SPECIAL_CONTACT_TYPE_SUCCESS";
export const RemoveSpecialContactTypeError = "REMOVE_SPECIAL_CONTACT_TYPE_ERROR";
export const SetCurrentSpecialContactType = "SET_SHOW_CURRENT_SPECIAL_CONTACT_TYPE";
export const SetShowSpecialContactTypeModal = "SHOW_SPECIAL_CONTACT_TYPE_MODAL";
export const SetShowDeleteSpecialContactTypeModal = "SHOW_DELETE_SPECIAL_CONTACT_TYPE_MODAL";

// User Permissions
export const GetEffectiveUserPermissions = "GET_EFFECTIVE_USER_PERMISSIONS";
export const GetEffectiveUserPermissionsSuccess = "GET_EFFECTIVE_USER_PERMISSIONS_SUCCESS";
export const GetEffectiveUserPermissionsError = "GET_EFFECTIVE_USER_PERMISSIONS_ERROR";
export const UpdateEffectiveUserPermissions = "UPDATE_EFFECTIVE_USER_PERMISSIONS";
export const UpdateEffectiveUserPermissionsSuccess = "UPDATE_EFFECTIVE_USER_PERMISSIONS_SUCCESS";
export const UpdateEffectiveUserPermissionsError = "UPDATE_EFFECTIVE_USER_PERMISSIONS_ERROR";
export const GetEffectiveUserPermissionsSchema = "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA";
export const GetEffectiveUserPermissionsSchemaSuccess =
  "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA_SUCCESS";
export const GetEffectiveUserPermissionsSchemaError = "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA_ERROR";

// User Accounts
export const GetUserAccounts = "GET_USER_ACCOUNTS";
export const GetUserAccountsSuccess = "GET_USER_ACCOUNTS_SUCCESS";
export const GetUserAccountsError = "GET_USER_ACCOUNTS_ERROR";
export const ExportUserAccounts = "EXPORT_USER_ACCOUNTS";
export const ExportUserAccountsSuccess = "EXPORT_USER_ACCOUNTS_SUCCESS";
export const ExportUserAccountsError = "EXPORT_USER_ACCOUNTS_ERROR";
// Client User Types
export const GetUserTypes = "GET_USER_TYPES";
export const GetUserTypesSuccess = "GET_USER_TYPES_SUCCESS";
export const GetUserTypesError = "GET_USER_TYPES_ERROR";

// Reporting Parameters
export const GetReportingParameters = "GET_REPORTING_PARAMETERS";
export const GetReportingParametersSuccess = "GET_REPORTING_PARAMETERS_SUCCESS";
export const GetReportingParametersError = "GET_REPORTING_PARAMETERS_ERROR";
export const UpdateReportingParameters = "UPDATE_REPORTING_PARAMETERS";
export const UpdateReportingParametersSuccess = "UPDATE_REPORTING_PARAMETERS_SUCCESS";
export const UpdateReportingParametersError = "UPDATE_REPORTING_PARAMETERS_ERROR";
export const GetReportingParametersSchema = "GET_REPORTING_PARAMETERS_SCHEMA";
export const GetReportingParametersSchemaSuccess = "GET_REPORTING_PARAMETERS_SCHEMA_SUCCESS";
export const GetReportingParametersSchemaError = "GET_REPORTING_PARAMETERS_SCHEMA_ERROR";
export const GetReasonsToBeExcluded = "GET_REASONS_TO_BE_EXCLUDED";
export const GetReasonsToBeExcludedSuccess = "GET_REASONS_TO_BE_EXCLUDED_SUCCESS";
export const GetReasonsToBeExcludedError = "GET_REASONS_TO_BE_EXCLUDED_ERROR";
export const CreateReasonToBeExcluded = "CREATE_REASON_TO_BE_EXCLUDED";
export const CreateReasonToBeExcludedSuccess = "CREATE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const CreateReasonToBeExcludedError = "CREATE_REASON_TO_BE_EXCLUDED_ERROR";
export const UpdateReasonToBeExcluded = "UPDATE_REASON_TO_BE_EXCLUDED";
export const UpdateReasonToBeExcludedSuccess = "UPDATE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const UpdateReasonToBeExcludedError = "UPDATE_REASON_TO_BE_EXCLUDED_ERROR";
export const DeleteReasonToBeExcluded = "DELETE_REASON_TO_BE_EXCLUDED";
export const DeleteReasonToBeExcludedSuccess = "DELETE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const DeleteReasonToBeExcludedError = "DELETE_REASON_TO_BE_EXCLUDED_ERROR";
export const GetReasonsToBeExcludedSchema = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA";
export const GetReasonsToBeExcludedSchemaSuccess = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA_SUCCESS";
export const GetReasonsToBeExcludedSchemaError = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA_ERROR";
export const ToggleReasonsToBeExcludedModal = "TOGGLE_REASONS_TO_BE_EXCLUDED_MODAL";
export const SetEditReasonToBeExcluded = "SET_EDIT_REASON_TO_BE_EXCLUDED";
export const ToggleDeleteReasonToBeExcludedConfirmModal =
  "TOGGLE_DELETE_REASON_TO_BE_EXCLUDED_CONFIRM_MODAL";
export const ToggleScheduledReportsWarningModal = "TOGGLE_SCHEDULED_REPORTS_WARNING_MODAL";

// Employee Identify
export const GetEmployeeIdentityData = "GET_EMPLOYEE_IDENTITY_DATA";
export const GetEmployeeIdentityDataSuccess = "GET_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const GetEmployeeIdentityDataError = "GET_EMPLOYEE_IDENTITY_DATA_ERROR";
export const UpdatePlatformDataSecurityEmployeeIdentity = "UPDATE_EMPLOYEE_IDENTITY_DATA";
export const UpdatePlatformDataSecurityEmployeeIdentitySuccess =
  "UPDATE_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const UpdatePlatformDataSecurityEmployeeIdentityError =
  "UPDATE_EMPLOYEE_IDENTITY_DATA_ERROR";
export const GetPlatformDataSecurityEmployeeIdentitySchema = "GET_EMPLOYEE_IDENTITY_SCHEMA";
export const GetPlatformDataSecurityEmployeeIdentitySchemaSuccess =
  "GET_EMPLOYEE_IDENTITY_SCHEMA_SUCCESS";
export const GetPlatformDataSecurityEmployeeIdentitySchemaError =
  "GET_EMPLOYEE_IDENTITY_SCHEMA_ERROR";

// Dynamic Questions
export const GetDynamicQuestions = "GET_DYNAMIC_QUESTIONS";
export const GetDynamicQuestionsSuccess = "GET_DYNAMIC_QUESTIONS_SUCCESS";
export const GetDynamicQuestionsError = "GET_DYNAMIC_QUESTIONS_ERROR";
export const SetShowAddDynamicQuestionModal = "SET_SHOW_ADD_DYNAMIC_QUESTION_MODAL";
export const NewDynamicQuestion = "NEW_DYNAMIC_QUESTION";
export const UpdateDynamicQuestionDraft = "UPDATE_DYNAMIC_QUESTION_DRAFT";
export const SetDynamicQuestionRevisionSchema = "SET_DYNAMIC_QUESTION_REVISION_SCHEMA";
export const AddNewDynamicQuestion = "ADD_NEW_DYNAMIC_QUESTION";
export const AddNewDynamicQuestionSuccess = "ADD_NEW_DYNAMIC_QUESTION_SUCCESS";
export const AddNewDynamicQuestionError = "ADD_NEW_DYNAMIC_QUESTION_ERROR";
export const SetDynamicQuestionAssignments = "SET_DYNAMIC_QUESTION_ASSIGNMENTS";
export const SetDynamicQuestionDraftAssignments = "SET_DYNAMIC_QUESTION_DRAFT_ASSIGNMENTS";
export const GetDynamicQuestion = "GET_DYNAMIC_QUESTION";
export const GetDynamicQuestionSuccess = "GET_DYNAMIC_QUESTION_SUCCESS";
export const GetDynamicQuestionError = "GET_DYNAMIC_QUESTION_ERROR";
export const ShowDynamicQuestionEditModal = "SHOW_DYNAMIC_QUESTION_EDIT_MODAL";
export const UpdateDynamicQuestion = "UPDATE_DYNAMIC_QUESTION";
export const UpdateDynamicQuestionSuccess = "UPDATE_DYNAMIC_QUESTION_SUCCESS";
export const UpdateDynamicQuestionError = "UPDATE_DYNAMIC_QUESTION_ERROR";
export const UpdateDynamicQuestionAssignments = "UPDATE_DYNAMIC_QUESTION_ASSIGNMENTS";
export const UpdateDynamicQuestionAssignmentsError = "UPDATE_DYNAMIC_QUESTION_ASSIGNMENTS_ERROR";
export const ShowEditDynamicQuestionAssignmentsModal =
  "SHOW_EDIT_DYNAMIC_QUESTION_ASSIGNMENTS_MODAL";

// Default Standard Scripts
export const GetDefaultStandardScripts = "GET_DEFAULT_STANDARD_SCRIPTS";
export const GetDefaultStandardScriptsSuccess = "GET_DEFAULT_STANDARD_SCRIPTS_SUCCESS";
export const GetDefaultStandardScriptsError = "GET_DEFAULT_STANDARD_SCRIPTS_ERROR";
export const GetDefaultStandardScript = "GET_DEFAULT_STANDARD_SCRIPT";
export const GetDefaultStandardScriptSuccess = "GET_DEFAULT_STANDARD_SCRIPT_SUCCESS";
export const GetDefaultStandardScriptError = "GET_DEFAULT_STANDARD_SCRIPT_ERROR";
export const ToggleEditDefaultStandardScriptModal = "TOGGLE_EDIT_DEFAULT_STANDARD_SCRIPT_MODAL";
export const UpdateDefaultStandardScript = "UPDATE_DEFAULT_STANDARD_SCRIPT";
export const UpdateDefaultStandardScriptSuccess = "UPDATE_DEFAULT_STANDARD_SCRIPT_SUCCESS";
export const UpdateDefaultStandardScriptError = "UPDATE_DEFAULT_STANDARD_SCRIPT_ERROR";
export const UpdateDefaultStandardScriptDraft = "UPDATE_DEFAULT_STANDARD_SCRIPT_DRAFT";
export const SetDefaultStandardScriptStatus = "SET_DEFAULT_STANDARD_SCRIPT_STATUS";

// Standard Questions
export const GetStandardQuestions = "GET_STANDARD_QUESTIONS";
export const GetStandardQuestionsSuccess = "GET_STANDARD_QUESTIONS_SUCCESS";
export const GetStandardQuestionsError = "GET_STANDARD_QUESTIONS_ERROR";
export const SetShowAddStandardQuestionModal = "SET_SHOW_ADD_STANDARD_QUESTION_MODAL";
export const NewStandardQuestion = "NEW_STANDARD_QUESTION";
export const UpdateStandardQuestionDraft = "UPDATE_STANDARD_QUESTION_DRAFT";
export const SetStandardQuestionRevisionSchema = "SET_STANDARD_QUESTION_REVISION_SCHEMA";
export const AddNewStandardQuestion = "ADD_NEW_STANDARD_QUESTION";
export const AddNewStandardQuestionSuccess = "ADD_NEW_STANDARD_QUESTION_SUCCESS";
export const AddNewStandardQuestionError = "ADD_NEW_STANDARD_QUESTION_ERROR";
export const SetStandardQuestionAssignments = "SET_STANDARD_QUESTION_ASSIGNMENTS";
export const SetStandardQuestionDraftAssignments = "SET_STANDARD_QUESTION_DRAFT_ASSIGNMENTS";
export const GetStandardQuestion = "GET_STANDARD_QUESTION";
export const GetStandardQuestionSuccess = "GET_STANDARD_QUESTION_SUCCESS";
export const GetStandardQuestionError = "GET_STANDARD_QUESTION_ERROR";
export const ShowStandardQuestionEditModal = "SHOW_STANDARD_QUESTION_EDIT_MODAL";
export const UpdateStandardQuestion = "UPDATE_STANDARD_QUESTION";
export const UpdateStandardQuestionSuccess = "UPDATE_STANDARD_QUESTION_SUCCESS";
export const UpdateStandardQuestionError = "UPDATE_STANDARD_QUESTION_ERROR";
export const StartStandardQuestionDraftSuccess = "START_STANDARD_QUESTION_DRAFT_SUCCESS";
export const StartStandardQuestionDraftError = "START_STANDARD_QUESTION_DRAFT_ERROR";
export const UpdateStandardQuestionAssignments = "UPDATE_STANDARD_QUESTION_ASSIGNMENTS";
export const UpdateStandardQuestionAssignmentsError = "UPDATE_STANDARD_QUESTION_ASSIGNMENTS_ERROR";
export const ShowEditStandardQuestionAssignmentsModal =
  "SHOW_EDIT_STANDARD_QUESTION_ASSIGNMENTS_MODAL";

export const ToggleEmployeeUsersModal = "TOGGLE_EMPLOYEE_USERS_MODAL";

// App Adoption

export const GetAppAdoptionHighlights = "GET_APP_ADOPTION_HIGHLIGHTS";
export const GetAppAdoptionHighlightsSuccess = "GET_APP_ADOPTION_HIGHLIGHTS_SUCCESS";
export const GetAppAdoptionHighlightsError = "GET_APP_ADOPTION_HIGHLIGHTS_ERROR";

export const GetAppAdoptionDepartments = "GET_APP_ADOPTION_DEPARTMENTS";
export const GetAppAdoptionDepartmentsSuccess = "GET_APP_ADOPTION_DEPARTMENTS_SUCCESS";
export const GetAppAdoptionDepartmentsError = "GET_APP_ADOPTION_DEPARTMENTS_ERROR";

export const ExportAppAdoptionDepartments = "EXPORT_APP_ADOPTION_DEPARTMENTS";
export const ExportAppAdoptionDepartmentsSuccess = "EXPORT_APP_ADOPTION_DEPARTMENTS_SUCCESS";
export const ExportAppAdoptionDepartmentsError = "EXPORT_APP_ADOPTION_DEPARTMENTS_ERROR";
